// 导出页面为PDF格式
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
import { Document, Packer, Paragraph, TextRun, Table, TableRow, TableCell, AlignmentType, WidthType, BorderStyle, VerticalAlign, ImageRun } from 'docx'
import { saveAs } from 'file-saver'

export const exportPdf = async (fileName, elem, callback = () => {}) => {
  if (!elem) return
  fileName = fileName || new Date().getTime()
  //上下边距余白
  const topBtmVoid = 20
  //创绘制切割后绘制canvas用的canvas标签以及对应的context对象
  const perCanvas = document.createElement('canvas')
  perCanvas.style.backgroundColor = '#fff'
  const context = perCanvas.getContext('2d')

  // 将需要下载的html标签转成canvas标签，并获取对应的base64码
  const canvas = await html2Canvas(elem)
  const canvasData = canvas.toDataURL('image/jpeg', 1.0)

  // pdf的尺寸
  const pdfWidth = canvas.width
  const pdfHeight = pdfWidth * 1.414

  //切割后的canvas图片的宽高，就等于每页pdf的宽高
  perCanvas.width = pdfWidth
  perCanvas.height = pdfHeight

  // 每张图片的高度：适当减少topBtmVoid * 2，上下各留topBtmVoid边距
  const perHeight = pdfHeight - topBtmVoid * 2

  // 计算切割次数
  let splitCount = Math.ceil(canvas.height / perHeight)
  if (splitCount * perHeight < canvas.height) splitCount++

  //创建img对象，加载完整的canvas图片
  const img = new Image()
  img.src = canvasData

  //图片加载完成
  img.onload = function () {
    //创建pdf对象
    const pdf = new JsPDF('p', 'pt', [pdfWidth, pdfHeight])

    //切割canvas图片，贴到每一页pdf中
    for (let i = 0; i < splitCount; i++) {
      const startY = i * perHeight // 起始y坐标
      // 清空画布
      context.clearRect(0, 0, perCanvas.width, pdfHeight)
      context.fillStyle = '#fff'
      context.fillRect(0, 0, perCanvas.width, pdfHeight)
      // 绘制当前切割区域的图片
      context.drawImage(
        img,
        0,
        startY,
        perCanvas.width,
        perHeight,
        0,
        0,
        perCanvas.width,
        perHeight
      )
      const perCanvasData = perCanvas.toDataURL('image/jpeg', 1.0)
      pdf.addImage(
        perCanvasData,
        'JPEG',
        0,
        topBtmVoid,
        perCanvas.width,
        perCanvas.height
      )
      if (i < splitCount - 1) pdf.addPage()
    }

    pdf.save(fileName + '.pdf')

    callback && callback()
  }
}

export const exportPdf2 = async (fileName, element, callback = () => {}) => {
  if (!element) return
  fileName = fileName || new Date().getTime()

  // 尺寸的确定
  const originWidth = element.offsetWidth || 700
  // 创建一个容器，用于克隆元素
  const container = document.createElement('div')
  // 16px是为了生成的PDF有安全边距
  container.style.cssText = `position:fixed;left: ${
    -2 * originWidth
  }px; top:0;padding:16px;width:${originWidth}px;box-sizing:content-box;`
  // 插入到body中
  document.body.appendChild(container)
  // 克隆元素
  container.appendChild(element.cloneNode(true))
  // 为了保证显示质量，2倍PDF尺寸
  const scale = 2
  const width = originWidth + 32

  const PDF_WIDTH = width * scale
  const PDF_HEIGHT = PDF_WIDTH * 1.414

  // 渲染为图片并下载
  html2Canvas(container, {
    allowTaint: true,
    scale: scale
  }).then(function (canvas) {
    const contentWidth = canvas.width
    const contentHeight = canvas.height

    // 一页pdf显示html页面生成的canvas高度
    const pageHeight = (contentWidth / PDF_WIDTH) * PDF_HEIGHT

    // canvas图像在画布上的尺寸
    const imgWidth = PDF_WIDTH
    const imgHeight = (PDF_WIDTH / contentWidth) * contentHeight

    let leftHeight = contentHeight
    let position = 0

    const doc = new JsPDF('p', 'px', [PDF_WIDTH, PDF_HEIGHT])

    // 不足一页
    if (leftHeight < pageHeight) {
      doc.addImage(canvas, 'JPEG', 0, 0, imgWidth, imgHeight)
    } else {
      // 多页
      while (leftHeight > 0) {
        doc.addImage(canvas, 'JPEG', 0, position, imgWidth, imgHeight)
        leftHeight -= pageHeight
        position -= PDF_HEIGHT
        //避免添加空白页
        if (leftHeight > 0) {
          doc.addPage()
        }
      }
    }

    doc.save(fileName + '.pdf')

    // 移除创建的元素
    container.remove()

    // 隐藏全局loading提示
    callback()
  })
}

// 导出HTML为Word文档
export const exportWord = (fileName, element, callback = () => {}) => {
  if (!element) return
  fileName = fileName || new Date().getTime()

  // 获取所有样式表
  const getStyles = () => {
    let allStyles = ''
    
    // 获取所有样式表
    Array.from(document.styleSheets).forEach(styleSheet => {
      try {
        Array.from(styleSheet.cssRules || []).forEach(rule => {
          allStyles += rule.cssText + '\n'
        })
      } catch (e) {
        // 跨域样式表可能无法访问，尝试获取link标签的href
        try {
          if (styleSheet.href) {
            allStyles += `@import url("${styleSheet.href}");\n`
          }
        } catch (e2) {
          // 忽略错误
        }
      }
    })

    // 添加通用样式，确保Word文档正确显示
    const commonStyles = `
      * {
        box-sizing: border-box;
      }
      body {
        margin: 0;
        padding: 20px;
        font-family: 'Microsoft YaHei', Arial, sans-serif;
        font-size: 14px;
      }
      .repair-list-header {
        text-align: center;
        margin-bottom: 20px;
      }
      .title {
        font-size: 24px;
        font-weight: bold;
        margin: 0;
        text-align: center;
      }
      h1 {
        text-align: center;
      }
      table {
        width: 100%;
        border-collapse: collapse;
        border: none;
      }
      table td, table th {
        border: 1px solid #000000;
        padding: 8px;
      }
      .info-table {
        width: 100%;
        margin-bottom: 20px;
      }
      .info-table th, .info-table td {
        padding: 8px;
        border: none;
      }
      .info-table .label {
        width: 100px;
        font-weight: bold;
      }
      .info-table .value {
        width: 200px;
      }
    `

    return `<style>${commonStyles}${allStyles}</style>`
  }

  // 直接使用innerHTML，保留所有原始结构和属性
  const htmlContent = element.innerHTML
  const styles = getStyles()

  // 创建Word文档格式的HTML
  const wordContent = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:w="urn:schemas-microsoft-com:office:word"
          xmlns="http://www.w3.org/TR/REC-html40">
    <head>
      <meta charset="utf-8">
      <meta name="ProgId" content="Word.Document">
      <meta name="Generator" content="Microsoft Word">
      <meta name="Originator" content="Microsoft Word">
      <title>${fileName}</title>
      ${styles}
      <!--[if gte mso 9]>
      <xml>
        <w:WordDocument>
          <w:View>Print</w:View>
          <w:Zoom>90</w:Zoom>
          <w:DoNotOptimizeForBrowser/>
          <w:ValidateAgainstSchemas/>
          <w:SaveIfXMLInvalid>false</w:SaveIfXMLInvalid>
          <w:IgnoreMixedContent>false</w:IgnoreMixedContent>
          <w:AlwaysShowPlaceholderText>false</w:AlwaysShowPlaceholderText>
          <w:Compatibility>
            <w:BreakWrappedTables/>
            <w:SnapToGridInCell/>
            <w:WrapTextWithPunct/>
            <w:UseAsianBreakRules/>
            <w:DontGrowAutofit/>
          </w:Compatibility>
        </w:WordDocument>
      </xml>
      <![endif]-->
    </head>
    <body>
      ${htmlContent}
    </body>
    </html>
  `

  // 创建Blob对象
  const blob = new Blob(['\ufeff', wordContent], {
    type: 'application/msword'
  })

  // 创建下载链接
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = fileName + '.doc'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  // 释放URL对象
  setTimeout(() => {
    URL.revokeObjectURL(link.href)
  }, 100)

  callback && callback()
}

// 导出为真正的 docx 文档（按页面样式映射）
export const exportDocx = async (fileName, element, callback = () => {}) => {
  if (!element) return
  fileName = fileName || new Date().getTime()

  try {
    const getAlignment = textAlign => {
      const val = (textAlign || '').toLowerCase()
      if (val === 'center') return AlignmentType.CENTER
      if (val === 'right' || val === 'end') return AlignmentType.RIGHT
      if (val === 'justify') return AlignmentType.JUSTIFIED
      return AlignmentType.LEFT
    }

    const rgbToHex = rgb => {
      if (!rgb || rgb === 'transparent') return ''
      if (rgb.startsWith('#')) return rgb.replace('#', '').toUpperCase()

      // 支持 rgb(...) / rgba(...)
      const match = rgb.match(/rgba?\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)(?:\s*,\s*([0-9.]+))?\s*\)/i)
      if (!match) return ''

      const r = Number(match[1])
      const g = Number(match[2])
      const b = Number(match[3])
      const a = match[4] !== undefined ? Number(match[4]) : 1
      // alpha=0 视为透明，不给单元格底色（否则会把透明误判成黑色背景）
      if (a === 0) return ''

      return [r, g, b]
        .map(n => Number(n).toString(16).padStart(2, '0'))
        .join('')
        .toUpperCase()
    }

    const createParagraphFromElement = (el, text) => {
      const style = window.getComputedStyle(el)
      const sizePx = Number.parseFloat(style.fontSize || '14')
      const isBold = Number(style.fontWeight) >= 600 || style.fontWeight === 'bold'
      const color = rgbToHex(style.color)

      return new Paragraph({
        alignment: getAlignment(style.textAlign),
        spacing: {
          before: 60,
          after: 60,
          line: 300
        },
        children: [
          new TextRun({
            text,
            bold: isBold,
            color: color || undefined,
            size: Number.isNaN(sizePx) ? 28 : Math.round(sizePx * 2)
          })
        ]
      })
    }

    const createTableCell = (td, colCount) => {
      const text = (td.innerText || td.textContent || '').trim()
      const style = window.getComputedStyle(td)
      const bg = rgbToHex(style.backgroundColor)
      const borderColor = rgbToHex(style.borderColor) || '000000'
      const colSpan = Number(td.colSpan) || 1
      const rowSpan = Number(td.rowSpan) || 1

      const lines = text ? text.split('\n').filter(Boolean) : ['']
      const paragraphs = lines.map(line => createParagraphFromElement(td, line))

      return new TableCell({
        width: {
          size: (100 * colSpan) / (colCount || 1),
          type: WidthType.PERCENTAGE
        },
        columnSpan: colSpan > 1 ? colSpan : undefined,
        rowSpan: rowSpan > 1 ? rowSpan : undefined,
        verticalAlign: VerticalAlign.CENTER,
        shading: bg ? { fill: bg } : undefined,
        margins: { top: 80, bottom: 80, left: 80, right: 80 },
        borders: {
          top: { style: BorderStyle.SINGLE, size: 2, color: borderColor },
          bottom: { style: BorderStyle.SINGLE, size: 2, color: borderColor },
          left: { style: BorderStyle.SINGLE, size: 2, color: borderColor },
          right: { style: BorderStyle.SINGLE, size: 2, color: borderColor }
        },
        children: paragraphs
      })
    }

    const getImageData = async src => {
      if (!src) return null

      try {
        if (src.startsWith('data:')) {
          const base64 = src.split(',')[1]
          if (!base64) return null
          const binary = atob(base64)
          const bytes = new Uint8Array(binary.length)
          for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i)
          }
          return bytes
        }

        const resp = await fetch(src)
        if (!resp.ok) return null
        const buffer = await resp.arrayBuffer()
        return new Uint8Array(buffer)
      } catch (error) {
        return null
      }
    }

    const docChildren = []
    const reportRoot = element.querySelector('.repair-list-export') || element.firstElementChild || element

    const pushTitle = node => {
      const text = (node.innerText || node.textContent || '').trim()
      if (!text) return
      const style = window.getComputedStyle(node)
      const sizePx = Number.parseFloat(style.fontSize || '24')
      docChildren.push(
        new Paragraph({
          alignment: AlignmentType.CENTER,
          spacing: { before: 120, after: 180, line: 360 },
          children: [
            new TextRun({
              text,
              bold: true,
              size: Number.isNaN(sizePx) ? 48 : Math.round(sizePx * 2)
            })
          ]
        })
      )
    }

    const pushTable = tableNode => {
      const rows = Array.from(tableNode.rows || [])
      if (!rows.length) return

      const caption = tableNode.caption ? (tableNode.caption.innerText || '').trim() : ''
      if (caption) {
        docChildren.push(createParagraphFromElement(tableNode.caption, caption))
      }

      const colCount = Math.max(
        1,
        ...rows.map(r =>
          Array.from(r.cells || []).reduce((sum, c) => sum + (Number(c.colSpan) || 1), 0)
        )
      )

      const tableRows = rows.map(tr => {
        const cells = Array.from(tr.cells || [])
        return new TableRow({
          children: cells.map(td => createTableCell(td, colCount))
        })
      })

      docChildren.push(
        new Table({
          width: { size: 100, type: WidthType.PERCENTAGE },
          borders: {
            top: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
            bottom: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
            left: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
            right: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
            insideHorizontal: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
            insideVertical: { style: BorderStyle.SINGLE, size: 2, color: '000000' }
          },
          rows: tableRows
        })
      )
      docChildren.push(new Paragraph({ text: '', spacing: { after: 120 } }))
    }

    const pushPlainTextBlock = node => {
      const text = (node.innerText || node.textContent || '').trim()
      if (!text) return
      text
        .split('\n')
        .map(line => line.trim())
        .filter(Boolean)
        .forEach(line => {
          docChildren.push(createParagraphFromElement(node, line))
        })
    }

    const pushImage = async node => {
      const src = node.currentSrc || node.src || node.getAttribute('src')
      if (!src) return

      const imageData = await getImageData(src)
      if (!imageData) return

      const style = window.getComputedStyle(node)
      const width = Math.round(
        Number.parseFloat(style.width || '') ||
          node.clientWidth ||
          node.naturalWidth ||
          280
      )
      const height = Math.round(
        Number.parseFloat(style.height || '') ||
          node.clientHeight ||
          node.naturalHeight ||
          200
      )

      docChildren.push(
        new Paragraph({
          spacing: { before: 80, after: 120 },
          children: [
            new ImageRun({
              data: imageData,
              transformation: {
                width: Math.max(1, width),
                height: Math.max(1, height)
              }
            })
          ]
        })
      )
    }

    const processNode = async node => {
      if (!node || node.nodeType !== 1) return
      const el = node
      const tag = (el.tagName || '').toUpperCase()

      if (tag === 'TABLE') {
        pushTable(el)
        return
      }

      if (tag === 'IMG') {
        await pushImage(el)
        return
      }

      if (tag === 'H1' || el.classList.contains('title') || el.classList.contains('repair-list-header')) {
        pushTitle(el)
        return
      }

      const childElements = Array.from(el.children || [])
      const hasTableChild = childElements.some(child => (child.tagName || '').toUpperCase() === 'TABLE')

      if (hasTableChild || childElements.length > 0) {
        for (const child of childElements) {
          await processNode(child)
        }
        return
      }

      pushPlainTextBlock(el)
    }

    await processNode(reportRoot)

    if (!docChildren.length) {
      const text = element.textContent || ''
      if (text) {
        docChildren.push(new Paragraph(text))
      }
    }

    const doc = new Document({
      sections: [
        {
          properties: {},
          children: docChildren
        }
      ]
    })

    const blob = await Packer.toBlob(doc)
    saveAs(blob, `${fileName}.docx`)
  } catch (e) {
    // 如果出错，回退到原来的 HTML 伪 Word 导出
    exportWord(fileName, element, callback)
    return
  }

  callback && callback()
}
